import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip, { TooltipConstants } from '@Components/Tooltip';

import '../InfoTooltip.custom.scss';
import '../InfoTooltip.theme.scss';

export default class InfoTooltipOnHover extends React.PureComponent {
  render() {
    const { id, className, ...otherProps } = this.props;

    return <Tooltip id={id} multiline html className={classnames([TooltipConstants.hoverableClassName, className])} {...otherProps} />;
  }
}

InfoTooltipOnHover.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};
